/**
 * Page definitions for all the Excel-driven routes.
 * Content is used verbatim as provided — nothing invented.
 *
 * "slug" is the current canonical URL. "oldSlugs" lists legacy paths that
 * should 301-redirect to the canonical slug (used by <LegacyRedirects />).
 */
export const excelServicePages = [
  {
    slug: '/backlink-audit',
    oldSlugs: [],
    eyebrow: 'SEO · Backlink Audit',
    title: 'FREE Backlink Audit',
    titleItalic: 'Toxic Backlink Audit & Removal Services Sydney',
    metaTitle: 'FREE Backlink Audit — Toxic Backlink Removal Sydney',
    description:
      'A backlink audit is a process in which our experts will examine all of the links that point to your website and assesses their quality. Contact us today!',
  },
  {
    slug: '/competitor-analysis',
    oldSlugs: [],
    eyebrow: 'SEO · Competitor Analysis',
    title: 'Competitor Analysis',
    titleItalic: 'SEO Competitor Analysis Services Sydney',
    description:
      'Our SEO competitor analysis services help you collect relevant, useful data about your competitors and more. Reach to our experts today and get a FREE quote!',
  },
  {
    slug: '/content-marketing-services',
    oldSlugs: [],
    eyebrow: 'SEO · Content Marketing',
    title: 'Content Marketing Services',
    titleItalic: 'Content Writing Services Sydney',
    description:
      'Content marketing is a big part of what we do here at GWM Sydney. Whether you need to create, publish or distribute content (or all three!), we’ve got you covered!',
  },
  {
    slug: '/digital-marketing-services',
    oldSlugs: [],
    eyebrow: 'Digital Marketing',
    title: 'Digital Marketing',
    titleItalic: 'Digital Marketing Services Sydney',
    description:
      'Your digital marketing campaign should draw you closer to your target audience and enable you to show them who you are and how you can help. Give us a call today!',
  },
  {
    slug: '/ecommerce-seo',
    oldSlugs: [],
    eyebrow: 'SEO · eCommerce',
    title: 'eCommerce SEO',
    titleItalic: 'Best eCommerce SEO Services Sydney',
    description:
      'Our advanced eCommerce SEO services are the best in the market. We’ll help you improve your numbers and reach new clients so your business can thrive and grow. Call NOW!',
  },
  {
    slug: '/enterprise-seo-services',
    oldSlugs: ['/enterprise-seo'],
    eyebrow: 'SEO · Enterprise',
    title: 'Enterprise SEO Services',
    titleItalic: 'Best Enterprise SEO Services Sydney',
    description:
      'Our enterprise SEO services will meet the requirements of your business, no matter the scope of your digital marketing strategy. Call us NOW for a FREE quote!',
    contentKey: '/enterprise-seo',
  },
  {
    slug: '/google-ads-management',
    oldSlugs: ['/service/google-ads-management'],
    eyebrow: 'PPC · Google Ads',
    title: 'Google Ads Management',
    titleItalic: 'Google AdWords Services Sydney',
    description:
      'Our PPC and Google Ads Management team has years of experience managing businesses’ accounts from many different niches. Give us a call today for a FREE quote!',
  },
  {
    slug: '/google-penalty-removal',
    oldSlugs: ['/services/google-penalty-removal'],
    eyebrow: 'SEO · Google Penalty Removal',
    title: 'Google Penalty Removal',
    titleItalic: 'Google Manual Penalty Removal Services Sydney',
    metaTitle: 'Google Penalty Removal — Manual Penalty Removal Sydney',
    description:
      'As an accomplished, experienced SEO agency, GWM Sydney will help you overcome the hurdles and remove the Google Penalty off your website. Call us NOW to learn more!',
  },
  {
    slug: '/landing-page-design',
    oldSlugs: [],
    eyebrow: 'Web Design · Landing Pages',
    title: 'Landing Page Design',
    titleItalic: 'Best Landing Page Design Services Sydney',
    description:
      'GWM can create well-functioning, beautifully designed website landing pages that will suit the needs of your brand and company perfectly. Call NOW for a FREE quote!',
  },
  {
    slug: '/lead-generation-seo',
    oldSlugs: [],
    eyebrow: 'SEO · Lead Generation',
    title: 'Lead Generation SEO',
    titleItalic: 'Best Lead Generation SEO Services Sydney',
    description:
      'GWM is the top SEO lead generation service in the region. And we take our job seriously. So, fill the form on our website or call us NOW to get a FREE quote!',
  },
  {
    slug: '/link-building-services',
    oldSlugs: ['/services/link-building'],
    eyebrow: 'SEO · Link Building',
    title: 'Link Building Services',
    titleItalic: 'Best SEO Link Building Services Sydney',
    description:
      "Our experts know that what's the best way to go about link building, with a good mixture of dofollow and nofollow links to make your portfolio seems more natural.",
  },
  {
    slug: '/local-seo',
    oldSlugs: ['/local-seo-services', '/services/local-seo'],
    eyebrow: 'SEO · Local',
    title: 'Local SEO Services',
    titleItalic: 'Local SEO Management Sydney',
    description:
      'Local SEO is a very effective way of promoting your business online. You’re able to offer your products and services to potential customers in your area. Call us NOW!',
    contentKey: '/local-seo-services',
  },
  {
    slug: '/remarketing',
    oldSlugs: [],
    eyebrow: 'PPC · Remarketing',
    title: 'Google Remarketing',
    titleItalic: 'Google & PPC Remarketing Campaigns Sydney',
    description:
      'Google remarketing or PPC remarketing campaign requires a lot of work and a team of trained professionals that know how to apply the right strategies. Call us today!',
  },
  {
    slug: '/seo-reseller-services',
    oldSlugs: [],
    eyebrow: 'SEO · Reseller',
    title: 'SEO Reseller Services',
    titleItalic: 'White Label SEO Reseller Sydney',
    description:
      'SEO reseller services can help your agency achieve outstanding results, without you having to hire more people for your team. Call us NOW to learn more!',
  },
  {
    slug: '/seo-services',
    oldSlugs: ['/service/search-engine-optimisation'],
    eyebrow: 'SEO · Services',
    title: 'SEO Services Sydney',
    titleItalic: 'Best SEO Services Sydney',
    description:
      'Our professional SEO services will help you rank high in SERPs so that you get more inquiry calls, in-store visits or purchases in your online store. Call us NOW!',
  },
  {
    slug: '/shopify-seo',
    oldSlugs: [],
    eyebrow: 'SEO · Shopify',
    title: 'Shopify SEO',
    titleItalic: 'Best Shopify SEO Services Sydney',
    description:
      'Using our state-of-the-art Shopify SEO services, we help you target the right demographics, increase your traffic and grow your business. Call for a FREE quote NOW!',
  },
  {
    slug: '/seo-for-small-business',
    oldSlugs: ['/small-business-seo', '/services/seo-small-business'],
    eyebrow: 'SEO · Small Business',
    title: 'SEO for Small Business',
    titleItalic: 'Small Business SEO Services Sydney',
    description:
      'You need small business SEO services to run your business effectively, reach your ideal customer and get the most out of your local searches. Call our experts NOW!',
    contentKey: '/small-business-seo',
  },
  {
    slug: '/website-seo-audit',
    oldSlugs: [],
    eyebrow: 'SEO · Website Audit',
    title: 'Website SEO Audit',
    titleItalic: 'FREE Website SEO Audit Service Sydney',
    description:
      'With our website audit service, we will uncover any technical issues that might weaken your optimisation efforts. Call us NOW to learn more from our experts!',
  },
  {
    slug: '/white-label-seo',
    oldSlugs: [],
    eyebrow: 'SEO · White Label',
    title: 'White Label SEO',
    titleItalic: 'Best White Label SEO Services Sydney',
    description:
      'If you run a business and want to improve the quality of your marketing for clients using white label SEO reseller services, you’ve come to the right place! Call NOW!',
  },
  {
    slug: '/wordpress-seo',
    oldSlugs: [],
    eyebrow: 'SEO · WordPress',
    title: 'WordPress SEO',
    titleItalic: 'Best WordPress SEO Services Sydney',
    description:
      'Our expert team, with our state-of-the-art WordPress SEO services, can help you increase traffic to your site, build your authority and grow your business. Call NOW!',
  },
];

export default excelServicePages;
